/**
 * Component Registry for Cobalt Theme
 * 
 * Extends the base landing-page theme registry with Cobalt specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as baseRegistry } from '@vibesites/theme-landing-page/registry';
import { Footer } from './components/Footer';

/**
 * Cobalt specific component overrides.
 * These components have been customized for the Cobalt brand.
 */
const cobaltOverrides: Partial<ComponentRegistry> = {
  Footer,
};

/**
 * Final merged registry for Cobalt properties.
 * Inherits all components from the landing-page theme, with Cobalt overrides.
 */
export const registry: ComponentRegistry = {
  ...baseRegistry,
  ...cobaltOverrides,
};

export default registry;
